import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  color: [],
  status: "all",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setColorFilter: (state, action) => {
      const colorIndex = state.color.indexOf(action.payload);
      if (colorIndex === -1) {
        state.color.push(action.payload);
      } else {
        state.color.splice(colorIndex, 1);
      }
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});
export default filterSlice.reducer;
export const { setColorFilter, setStatus } = filterSlice.actions;
